import { CommonModule } from '@angular/common';
import { ContactCardModule } from './../../shared-panel-components/contact-card/contact-card.module';
import { PanelListModule } from './../../shared-panel-components/panel-list/panel-list.module';
import { PanelModule } from './../../shared-panel-components/panel/panel.module';
import { BasicInfoPanelComponent } from './basic-info-panel.component';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [BasicInfoPanelComponent],
  imports: [PanelModule, PanelListModule, ContactCardModule, CommonModule],
  exports: [BasicInfoPanelComponent],
  providers: [],
})
export class BasicInfoPanelModule {}
